/* ==========================================================================
   DUNE INDEX — програма лояльності (sections/dune-loyalty.liquid)
   1. Заголовок по ширине колонки
   2. Карта: сама перебирает уровни, шторка со сканирующей линией, наклон за курсором
   3. Шкала-индекс: бегунок, уровень, процент, сколько до следующего; при первом
      появлении бегунок сам проезжает до GRAPHITE
   4. Ступени: счётчик процентов при появлении
   5. Условия: подсветка текущего раздела в рейке
   Появление блоков (data-dune-reveal) и посадку слова на направляющие (data-dune-fit)
   делает assets/dune.js.
   ========================================================================== */
(function () {
  'use strict';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var finePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var CYCLE = 3400;

  function money(n) {
    return String(Math.round(n)).replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
  }
  function easeOut(t) { return 1 - Math.pow(1 - t, 3); }

  function onVisible(el, cb, threshold) {
    if (!('IntersectionObserver' in window)) { cb(true); return null; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { cb(e.isIntersecting); });
    }, { threshold: threshold || 0 });
    io.observe(el);
    return io;
  }

  /* --- 1. Заголовок по ширине колонки ------------------------------------ */

  function initFit(root) {
    var box = root.querySelector('.dune-lty__titlebox');
    var title = root.querySelector('.dune-lty__title');
    var text = root.querySelector('[data-lty-fit]');
    if (!box || !title || !text) return;
    var fit = function () {
      title.style.fontSize = '';
      var w = text.getBoundingClientRect().width;
      var avail = box.clientWidth;
      if (!w || !avail) return;
      var fs = parseFloat(window.getComputedStyle(title).fontSize);
      title.style.fontSize = (fs * avail / w * 0.995).toFixed(2) + 'px';
    };
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(fit);
    fit();
    var t;
    window.addEventListener('resize', function () {
      clearTimeout(t);
      t = setTimeout(fit, 120);
    });
  }

  /* --- 2. Карта ------------------------------------------------------------ */

  function initCard(root) {
    var stage = root.querySelector('[data-lty-stage]');
    var card = root.querySelector('[data-lty-card]');
    var rail = root.querySelector('[data-lty-rail]');
    if (!stage || !card || !rail) return;
    var faces = card.querySelectorAll('[data-lty-face]');
    var ticks = rail.querySelectorAll('[data-lty-tick]');
    var current = 0;
    var held = false;
    var visible = false;
    var hover = false;
    var timer = null;

    rail.style.setProperty('--lty-cycle', CYCLE + 'ms');

    function restart(el, cls) {
      el.classList.remove(cls);
      void el.offsetWidth;
      el.classList.add(cls);
    }

    function show(i, animate) {
      if (i === current && animate) return;
      for (var k = 0; k < faces.length; k++) {
        faces[k].classList.remove('is-on', 'is-prev', 'is-wipe');
      }
      faces[current].classList.add('is-prev');
      faces[i].classList.add('is-on');
      if (animate && !reduced) {
        restart(faces[i], 'is-wipe');
        restart(card, 'is-scanning');
      }
      for (var j = 0; j < ticks.length; j++) {
        ticks[j].classList.toggle('is-active', j === i);
        ticks[j].setAttribute('aria-pressed', j === i ? 'true' : 'false');
      }
      rail.style.setProperty('--rail-x', (i * 100 / ticks.length) + '%');
      current = i;
    }

    function schedule() {
      clearTimeout(timer);
      rail.classList.remove('is-run');
      if (held || reduced || !visible || hover) return;
      restart(rail, 'is-run');
      timer = setTimeout(function () {
        show((current + 1) % faces.length, true);
        schedule();
      }, CYCLE);
    }

    for (var n = 0; n < ticks.length; n++) {
      ticks[n].addEventListener('click', function (e) {
        held = true;
        show(parseInt(e.currentTarget.getAttribute('data-lty-tick'), 10), true);
        schedule();
      });
    }

    onVisible(stage, function (on) { visible = on; schedule(); }, 0.35);
    document.addEventListener('visibilitychange', function () {
      visible = !document.hidden && visible;
      schedule();
    });

    if (finePointer && !reduced) {
      stage.addEventListener('pointerenter', function () {
        hover = true;
        stage.classList.add('is-tilting');
        schedule();
      });
      stage.addEventListener('pointermove', function (e) {
        var r = stage.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width - 0.5;
        var y = (e.clientY - r.top) / r.height - 0.5;
        card.style.setProperty('--rx', (-y * 12).toFixed(2) + 'deg');
        card.style.setProperty('--ry', (x * 16).toFixed(2) + 'deg');
        card.style.setProperty('--sheen', (x * 120 - 10).toFixed(1) + '%');
      });
      stage.addEventListener('pointerleave', function () {
        hover = false;
        stage.classList.remove('is-tilting');
        card.style.removeProperty('--rx');
        card.style.removeProperty('--ry');
        card.style.removeProperty('--sheen');
        schedule();
      });
    }
  }

  /* --- 3. Шкала-индекс ---------------------------------------------------- */

  function initScale(root) {
    var scale = root.querySelector('[data-lty-scale]');
    var range = root.querySelector('[data-lty-range]');
    if (!scale || !range) return;
    var max = parseFloat(range.max) || 200000;
    var levels = (range.getAttribute('data-levels') || '').split(',').map(function (s) {
      var p = s.split(':');
      return { name: p[0], from: parseFloat(p[1]) || 0, rate: p[2] };
    });
    var tag = root.querySelector('[data-lty-tag]');
    var out = {
      sum: root.querySelector('[data-lty-sum]'),
      level: root.querySelector('[data-lty-level]'),
      rate: root.querySelector('[data-lty-rate]'),
      nextLabel: root.querySelector('[data-lty-next-label]'),
      next: root.querySelector('[data-lty-next]')
    };
    var zones = root.querySelectorAll('[data-lty-zone]');
    var steps = root.querySelectorAll('[data-lty-step]');
    var touched = false;
    var last = -1;

    function update(v) {
      var idx = 0;
      for (var i = 0; i < levels.length; i++) {
        if (v >= levels[i].from) idx = i;
      }
      scale.style.setProperty('--p', (v / max).toFixed(4));
      if (tag) tag.textContent = money(v) + ' ₴';
      out.sum.textContent = money(v);
      out.level.textContent = levels[idx].name;
      out.rate.textContent = levels[idx].rate;
      var nx = levels[idx + 1];
      if (nx) {
        out.nextLabel.textContent = 'До ' + nx.name;
        out.next.innerHTML = '<b>' + money(nx.from - v) + '</b> ₴';
      } else {
        out.nextLabel.textContent = 'Наступний рівень';
        out.next.innerHTML = '<b>—</b>';
      }
      if (idx !== last) {
        for (var z = 0; z < zones.length; z++) zones[z].classList.toggle('is-current', z === idx);
        for (var s = 0; s < steps.length; s++) steps[s].classList.toggle('is-current', s === idx);
        last = idx;
      }
    }

    range.addEventListener('input', function () {
      touched = true;
      update(parseFloat(range.value));
    });
    ['pointerdown', 'keydown', 'touchstart'].forEach(function (ev) {
      range.addEventListener(ev, function () { touched = true; }, { passive: true });
    });
    update(parseFloat(range.value) || 0);

    // Демо: при первом появлении бегунок проезжает до середины GRAPHITE.
    var target = 96000;
    var io = onVisible(scale, function (on) {
      if (!on) return;
      if (io) io.disconnect();
      if (touched) return;
      if (reduced) { range.value = target; update(target); return; }
      var t0 = null;
      var dur = 2400;
      var step = function (ts) {
        if (touched) return;
        if (t0 === null) t0 = ts;
        var k = Math.min(1, (ts - t0) / dur);
        var v = Math.round(easeOut(k) * target / 1000) * 1000;
        range.value = v;
        update(v);
        if (k < 1) requestAnimationFrame(step);
      };
      setTimeout(function () { requestAnimationFrame(step); }, 300);
    }, 0.5);
  }

  /* --- 4. Счётчики процентов на ступенях --------------------------------- */

  function initCounts(root) {
    var box = root.querySelector('.dune-lty__steps');
    if (!box || reduced) return;
    var nums = box.querySelectorAll('[data-lty-count]');
    for (var i = 0; i < nums.length; i++) nums[i].textContent = '0';
    var io = onVisible(box, function (on) {
      if (!on) return;
      if (io) io.disconnect();
      Array.prototype.forEach.call(nums, function (el, n) {
        var to = parseFloat(el.getAttribute('data-lty-count')) || 0;
        var t0 = null;
        var delay = n * 140 + 250;
        var step = function (ts) {
          if (t0 === null) t0 = ts;
          var k = Math.min(1, Math.max(0, (ts - t0 - delay) / 900));
          el.textContent = String(Math.round(easeOut(k) * to));
          if (k < 1) requestAnimationFrame(step);
        };
        requestAnimationFrame(step);
      });
    }, 0.2);
  }

  /* --- 5. Условия: текущий раздел ----------------------------------------- */

  function initTerms(root) {
    var terms = root.querySelector('[data-lty-terms]');
    if (!terms || !('IntersectionObserver' in window)) return;
    var links = terms.querySelectorAll('.dune-lty__toc a');
    var map = {};
    for (var i = 0; i < links.length; i++) {
      map[links[i].getAttribute('href').slice(1)] = links[i].parentNode;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        for (var k in map) map[k].classList.toggle('is-active', k === e.target.id);
      });
    }, { rootMargin: '-35% 0px -60% 0px' });
    terms.querySelectorAll('.dune-lty__rule').forEach(function (el) { io.observe(el); });
  }

  /* --- Запуск ------------------------------------------------------------- */

  function init(scope) {
    (scope || document).querySelectorAll('[data-dune-loyalty]').forEach(function (root) {
      if (root.dataset.ltyReady) return;
      root.dataset.ltyReady = '1';
      root.classList.add('is-js');
      initFit(root);
      initCard(root);
      initScale(root);
      initCounts(root);
      initTerms(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
